import { RightOutlined } from '@ant-design/icons';
import { Space, Typography } from 'antd';
import { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { StyledCard, StyledCardHeader } from './styled';

const { Title } = Typography;

interface IProps {
  title: string;
  count: number;
  to?: string;
  children: React.ReactNode;
}

const CountCard: FC<IProps> = ({ title, count, to, children }) => {
  const navigate = useNavigate();

  const renderContent = () => (
    <StyledCard onClick={() => to && navigate(to)}>
      <StyledCardHeader>
        <Space>
          <Title level={5} style={{ color: '#18212C', margin: 0 }}>
            {title}
          </Title>
        </Space>
        {!!to && <RightOutlined style={{ fontSize: 24, color: '#4385F5' }} />}
      </StyledCardHeader>
      <Title level={2} style={{ color: '#18212C', margin: 0, fontSize: 32 }}>
        {count}
      </Title>
      {children}
    </StyledCard>
  );

  if (!to) {
    return <>{renderContent()}</>;
  }

  return <Link to={to}>{renderContent()}</Link>;
};

export default CountCard;
